import addressMatcher, { AddressType } from '@plug-core/utils/addressMatcher'
import { Button, Field, Input } from '@ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const AddressInput = ({ onAdd }: { onAdd: (address: string) => void }) => {
  const [address, setAddress] = useState('')

  const { t } = useTranslation()

  const addressInvalid = addressMatcher(address) === AddressType.Invalid

  return (
    <div className="flex flex-col gap-4">
      <Field label={t('contacts.addAddress')} error={addressInvalid}>
        <Input mono autoFocus value={address} onChange={(e) => setAddress(e.target.value)} />
      </Field>

      <Button
        fullWidth
        variant="primary"
        disabled={addressInvalid}
        onClick={() => !addressInvalid && onAdd(address)}
      >
        {t('common.add')}
      </Button>
    </div>
  )
}
